import { Snackbar, Typography } from '@mui/joy';

import { Button } from '~/components/ui/button';
import { Card } from '~/components/ui/card';

export default function ErrorToastAlert({
  open,
  handleClose,
  alertText,
  submitError,
}: Readonly<{
  open: boolean;
  handleClose: () => void;
  alertText: string;
  submitError: () => void;
}>) {
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={5000}
      className='!p-0'
    >
      <Card className='flex flex-col gap-2 w-full max-w-96'>
        <Typography level='body-md'>{alertText}</Typography>
        <Button
          variant='outlined'
          shape='pill'
          color='gradient-primary'
          onClick={submitError}
        >
          Submit ticket
        </Button>
      </Card>
    </Snackbar>
  );
}
